<template>
  <div>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{text}}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>

    <v-snackbar :top="y === 'top'" color="red" v-model="errorSnackbar">
      {{errorText}}
      <v-btn color="white" flat @click="errorSnackbar = false">X</v-btn>
    </v-snackbar>
    <v-toolbar flat color="white" class= "pt-3">
      <v-btn id="addContactId" color="primary" dark class="mb-2" @click="addItem()" round>ADD CONTACT</v-btn>
      <v-btn round color="primary"><v-icon>get_app</v-icon><download-excel
    :data="associatedcontacts"
    worksheet="export"
    :name="'Contacts_'+new Date().getTime()+'.xls'">
    Export to Excel
</download-excel></v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        id="searchId"
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
      ></v-text-field>
    </v-toolbar>

    <!-- Add new item modal //////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
    <!-- Add new item modal //////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
    
    <v-dialog persistent v-model="newDialog" max-width="750px">
      <v-card>

        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >ADD CONTACT</h1>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <h3 dark-grey--text>Personal Details</h3>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  id="addFirstNameId"
                  v-model="editedItem.name"
                  label="*First Name"
                  persistent-hint
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                  id="addSurnameId"
                  v-model="editedItem.surname"
                  label="*Surname"
                  persistent-hint
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <h3 dark-grey--text>Contact Details</h3>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  id="addMobileNumberId"
                  v-model="editedItem.mobileNumber"
                  label="*Mobile Number"
                  persistent-hint
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                  id="addTelephoneNumberId"
                  v-model="editedItem.telephoneNumber"
                  label="Telephone Number"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <h3 dark-grey--text>Login Settings</h3>
              </v-flex>
            
            <v-flex xs12 sm3 md6>
                <v-text-field
                  id="addEmailAddressId"
                  v-model="editedItem.emailAddress"
                  prepend-icon="email"
                  label="*Email Address"
                  persistent-hint
                  type="email"
                ></v-text-field>
               </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                 id="addPasswordId"
                 prepend-icon="vpn_key"
                 :append-icon="show1 ? 'visibility' : 'visibility_off'"          
                 :type="show1 ? 'text' : 'password'"
                 label="*Password"
                 v-model="editedItem.password"
                 @click:append="show1 = !show1"
                 ref="password"
                 v-on:blur="checkPassword"
       
                ></v-text-field>
                <span v-if="displayPasswordError == true" class="passWordError" >The password must contain atleast 8 characters consisting of atleast 1 uppercase letter, atleast 1 lowercase letter and atleast 1 number.</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-layout justify-center>
          <v-btn color="primary" round @click="close">Cancel</v-btn>
          <v-btn id="contactSaveAddButtonId" color="primary" round @click="saveNew">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
      
    <!-- Edit Modal //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////-->
    <v-dialog persistent v-model="dialog" width="750px">
<v-card>
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >EDIT CONTACT</h1>
        </v-toolbar>
 
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>

              <v-flex xs12 sm12 md12>
                <h3 dark-grey--text>Personal Details</h3>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  id="editFistNameId"  
                  v-model="editedItem.name"
                  label="*First Name"
                  persistent-hint
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="editedItem.surname"
                  label="*Surname"
                  persistent-hint
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <h3 dark-grey--text>Contact Details</h3>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="editedItem.mobileNumber"
                  label="*Mobile Number"
                  persistent-hint
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="editedItem.telephoneNumber"
                  label="Telephone Number"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <h3 dark-grey--text>Login Settings</h3>
              </v-flex>

              <v-flex xs12 sm3 md6>
                <v-text-field
                  v-model="editedItem.emailAddress"
                  prepend-icon="email"
                  label="*Email Address"
                  persistent-hint
                  type="email"
                   v-on:blur="checkEmail"
                ></v-text-field>
                <span v-if="displayEmailError == true" class="passWordError" >Please make sure that your email address is in the correct format.</span>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                 id="editPasswordId"
                 :append-icon="show1 ? 'visibility' : 'visibility_off'"          
                 :type="show1 ? 'text' : 'password'"
                 v-model="editedItem.password"
                 @click:append="show1 = !show1"
                 ref="password"
                 v-on:blur="checkPassword"
                 label="Reset Password"
                ></v-text-field>
                <span v-if="displayPasswordError == true" class="passWordError" >The password must contain atleast 8 characters consisting of atleast 1 uppercase letter, atleast 1 lowercase letter and atleast 1 number.</span>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-btn id="resetPasswordButtonId" flat color='primary' @click="resetPassword">Reset</v-btn>
                </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        



        <v-card-actions>
          <v-layout justify-center>
          <v-btn color="primary" round @click="close">Cancel</v-btn>
          <v-btn id="contactSaveEditButtonId" color="primary" round @click="save">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :rows-per-page-items="[25, 50, 100, 250, 500]"
      :loading="isloading"
      :search="search"
      :items="associatedcontacts"
      item-key="id"
      align-center
      style="cursor: pointer"
    >
      <template v-slot:items="props">
        <td class="justify-center layout px-0">
          <v-icon id="contactEditButtonId" small class="mr-2" @click="basicInformation=true;showTags=false; showLocations=false; editItem(props.item)">edit</v-icon>
          <v-icon v-if="$store.state.permission==='ISP'" id="contactEditButtonId" small class="mr-2" @click="deleteItem(props.item.id)">delete</v-icon>
          <!-- <v-icon small @click="deleteItem(props.item.id)">delete</v-icon> -->
        </td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.name}}</td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.surname}}</td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.mobileNumber}}</td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.telephoneNumber}}</td>
        <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.emailAddress}}</td>
        <td class="text-xs-center" v-if="props.item.isActive">
        <v-icon color="green">done</v-icon>
        </td>
        <td class="text-xs-center" v-else>
        <v-icon color="red">not_interested</v-icon>
        </td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>
  </div>
</template>
 
<script>
import Api from "@/services/Api";
// import Tags from "@/components/Tags.vue";
// import LocationNetworksLocations from "@/components/Locations/LocationNetworksLocations.vue";

export default {
  //  components: {
  //   tagscomponent: Tags,    
  //   locationnetworkslocations: LocationNetworksLocations
  //   },
  props: ['Contacts','associatedcontacts','isloading'],
  data() {
    return {
      editContactTypeId: null,
      tags: [],
      locationNetworksLocations: [],
      showLocations:false,
      basicInformation:false,
      showTags:false,
      swop: null,
      customerContactId: null,
      contactTypeIdAdd: null,
      customerIdAdd: null,
      show1: false,
      profilePictureSaved: true,
      imageInput:{},
      image: '',
      text: "",
      y: "top",
      snackbar: false,
      errorSnackbar: false,
      errorText: '',
      avatar: null,
      saving: false,
      saved: false,
      showDetails: true,
      loading: false,
      expand: false,
      search: "",
      dialog: false,
      newDialog: false,
      pagination: {},
      contactTypes: [],
      customers: [],
      headers: [
        {
          text: "Actions",
          align: "center"
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Surname",
          align: "center",
          value: "surname"
        },
        {
          text: "Mobile",
          align: "center",
          value: "mobileNumber"
        },
        {
          text: "Telephone",
          align: "center",
          value: "telephoneNumber"
        },
        {
          text: "Email",
          align: "center",
          value: "emailAddress"
        },
        {
          text: "Active",
          align: "center",
          value: "isActive"
        }
      ],
      totalcontacts: 0,
      editedIndex: -1,
      editedItem: {
        permissions: "",
        name: "",
        customerId: null,
        contactTypeId: null,
        surname: "",
        idNumber: "",
        mobileNumber: "",
        telephoneNumber: "",
        emailAddress: "",
        password: "",
        isActive: true,
        isDeleted: false
      },
      defaultItem: {
        contactTypeId: null,
        name: "",
        surname: "",
        idNumber: "",
        mobileNumber: "",
        telephoneNumber: "",
        emailAddress: "",
        password: "",
        isActive: true,
        isDeleted: false
      },
      displayPasswordError: false,
      displayEmailError: false
    };
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    enterEvent() { 
      return true     
    },
     routerLinkToDetails(item) { 
      this.editedIndex = this.associatedcontacts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$router.push({ path: "/contactSummary/" + this.editedItem.id });
  
    },
     uploadImage() {
      this.saving = true
      setTimeout(() => this.savedAvatar(), 1000)
    },
    checkPassword() {
     let passReg = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$")
      const match = passReg.test(this.editedItem.password)
      if (match) {
          this.displayPasswordError = false
         
       } else {
        this.displayPasswordError = true
      }
    },
     checkEmail() {
      let emailReg = new RegExp("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?")
      const match = emailReg.test(this.editedItem.emailAddress)
      if (match) {
          this.displayEmailError = false
       } else {
        this.displayEmailError = true
      }
    },
    validateBeforeSave(type) {
      let passedValidation = true
      if(type === 'new') {
      // validate password
        let passReg = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$")
      const match = passReg.test(this.editedItem.password)
      if (match) {
          this.displayPasswordError = false
         
       } else {
         passedValidation = false
        this.displayPasswordError = true,
         alert('The password must contain atleast 8 characters consisting of atleast 1 uppercase letter, atleast 1 lowercase letter and atleast 1 number.')
      }
      }
      if(type === 'edit' && this.editedItem.password != '') {
             let passReg = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$")
      const match = passReg.test(this.editedItem.password)
      if (match) {
          this.displayPasswordError = false
         
       } else {
         passedValidation = false
        this.displayPasswordError = true,
         alert('The password must contain atleast 8 characters consisting of atleast 1 uppercase letter, atleast 1 lowercase letter and atleast 1 number.')
      }
      }
      // validate email address
       let emailReg = new RegExp("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?")
      const matchEmail = emailReg.test(this.editedItem.emailAddress)
      if (matchEmail) {
          this.displayEmailError = false
       } else {
         passedValidation = false
        this.displayEmailError = true,
        alert('Please check that you have entered a valid email address.')
      }
      // validate mobile number
      if(this.editedItem.mobileNumber.length > 13){
          passedValidation = false
          alert('Please check that the mobile number you have entered has less than 14 digits.')
      }
       if(this.editedItem.name == '' || this.editedItem.surname == '' || this.$store.state.permissions == '' || this.editedItem.emailAddress == '' || this.editedItem.mobileNumber == '') {
          passedValidation = false
         alert('Please check that you have filled in all the required fields.')
      }
      
      return passedValidation
    },
    savedAvatar() {
      this.saving = false
      this.saved = true
    },  
    async fetchContactTypes(){
      await Api()
      .get('/contactTypes')
      .then(response=>{
        this.contactTypes=response.data
      })
    },
     fetchLocationsByContact(id){
      Api()
      .get('/LocationContact/byContact/' + id)
      .then(response=>{
        for(let i=0; i<response.data.length; i++){
        this.locationNetworksLocations.push(response.data[i].location)
        }
      })
    },
    fetchTagsByContact(id){
      Api()
      .get('/tags/showByContact/' + id)
      .then(response=>{
        for(let i=0; i<response.data.length; i++){
        this.tags.push(response.data[i])
        }
      })
    },
    fetchContactsByCustomer(customerId){
      this.associatedcontacts = []
          Api()
          .get('/customercontact/showByCustomer/'+customerId)
          .then(response=>{
             for (var i = 0; i < response.data.length; i++) {
     
                            let tempContactToPush = response.data[i].contact;
                            // tempContactToPush.contactType = response.data[i].contactType;
                            //  tempContactToPush.contactType.customerContactId = response.data[i].id;                            
                            (this.associatedcontacts).push(tempContactToPush);
                        }
          });
      },   
    initialize() {
     this.fetchContactTypes();     
    },
    onDrop: function(e) {
        e.stopPropagation();
        e.preventDefault();
        var files = e.dataTransfer.files;
        this.createFile(files[0]);
      },
      onChange(e) {
        var files = e.target.files;
        this.imageInput = files[0];
        this.createFile(files[0]);
      
      },
      sizeValidation(size) {
      
        if (size > 20000) {
            return false
      }
      else {
        return true
      }
      },
      createFile(file) {
        if (!file.type.match('image.*')) {
          alert('Select an image');
          return;
        }
        var img = new Image();
        var reader = new FileReader();
        var vm = this;
        reader.onload = function(e) {
          vm.image = e.target.result;
        }
        reader.readAsDataURL(file);
      },
      removeFile() {
      if(confirm("Are you sure you want to delete this image?") == true){
         this.image = '';
      }     
      },
      fetchFiles(){
        Api()
        .get("/files/active")
        .then(response => {
          this.files = response.data;
        });
      },    
      addItem(){
        if(this.authCreate(this.$store.state.currentRoute)){ 
        this.newDialog=true;this.basicInformation=true;this.showTags=false;this.showLocations=false;}
      },
    editItem(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){  
      this.editedItem = Object.assign({}, item);
      // this.editedItem.password = ''
      this.dialog = true; 
      }
    },
      deleteItem(id) {
        if(this.authDelete(this.$store.state.currentRoute)){
      confirm("Are you sure you want to delete this contact?") &&
      Api()
      .put('/contacts/'+id,{
        isActive: false,
        isDeleted: true
      })
      this.$emit("contacts");
        }
    },
    close() {
      this.dialog = false;
      this.newDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      // let validation = this.validateBeforeSave('edit')
      //  if(validation){
      Api().put("/contacts/" + this.editedItem.id, {
        name: this.editedItem.name,
        surname: this.editedItem.surname,
        mobileNumber: this.editedItem.mobileNumber,
        telephoneNumber: this.editedItem.telephoneNumber,
        emailAddress: this.editedItem.emailAddress
      }).then(response=>{
        this.text = 'Successfully updated contact!'
        this.snackbar = true
        this.$emit('contacts')
      })
      this.close();
      //  }
    },
    resetPassword(){
       let validation = this.validateBeforeSave('edit')
       if(validation){
         confirm('Are you sure you want to reset this password?')&&
      Api().put("/contacts/resetPassword/" + this.editedItem.id, {
        name: this.editedItem.name,
        surname: this.editedItem.surname,
        mobileNumber: this.editedItem.mobileNumber,
        password: this.editedItem.password,
        Password: this.editedItem.password,
        telephoneNumber: this.editedItem.telephoneNumber,
        permissions: this.editedItem.permissions,
        emailAddress: this.editedItem.emailAddress,
        isActive: this.editedItem.isActive
      }).then(response =>{
             this.text = "Password Successfully Reset!"
             this.snackbar = true
             this.dialog=false
                    this.$emit("contacts");
      } 
      )
      }
    },
    saveNew() {
      let validation = this.validateBeforeSave('new')
       if(validation){
         try {
           Api().post("/contacts", {
          name: this.editedItem.name,
          surname: this.editedItem.surname,
          mobileNumber: this.editedItem.mobileNumber,
          telephoneNumber: this.editedItem.telephoneNumber,
          emailAddress: this.editedItem.emailAddress,
          password: this.editedItem.password,
          isActive: true
        }).then((response)=>{
          // console.log(response)
          // if(response && response.status === 200){
          //   this.snackbar = true
          //   this.text = 'Successfully added contact!'
          // } else {
            this.$emit('contacts')
           this.snackbar = true
            this.text = 'Successfully added contact!'
        })
        
         } catch (err) {
           
           this.errorSnackbar = true
            this.errorText = "Error creating contact"
         }
         this.close();
        
       }
    }
  }
};
</script>
<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.passWordError {
  color: red;  
}
</style>
